import React, { useId } from "react";
import "./CheckBox.css";

const CheckBox = ({
  name,
  label,
  checked,
  defaultChecked = false,
  onChange,
  disabled = false,
  required = false,
  position = "left",
  boxSize = "small",
  className = "",
  containerStyle,
  inputStyle,
  labelStyle,
}) => {
  const generatedId = useId();
  const isControlled = checked !== undefined;

  return (
    <div
      className={[
        "c_checkbox__container",
        position,
        disabled && "c_checkbox--disabled",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      style={containerStyle}
    >
      <input
        id={generatedId}
        type="checkbox"
        name={name}
        className={`c_checkbox__input ${boxSize}`}
        checked={isControlled ? Boolean(checked) : undefined}
        defaultChecked={!isControlled ? defaultChecked : undefined}
        onChange={(event) => onChange?.(event.target.checked, event)}
        disabled={disabled}
        required={required}
        style={inputStyle}
      />

      {label && (
        <label
          htmlFor={generatedId}
          className="c_checkbox__label"
          style={labelStyle}
        >
          {label}

          {required && <span className="c_checkbox__required">*</span>}
        </label>
      )}
    </div>
  );
};

export default CheckBox;
